<template>
<div class="chapter">
<div class="inner_page">
<div style="display:none;"><a id="GBS.PP1"></a><a id="GBS.PP1.w.0.0.0"></a></div><div style="display:none;"><a id="GBS.PP1.w.1.0.0"></a></div>
<div class="flow" style="">
<a class="page full_page_image" id="ORIG-GBS.PP1"></a>
<a id="GBS.PP2"></a><a id="GBS.PP2.w.0.0.0"></a><a id="GBS.PP2.w.0.0.0.1"></a></div>
<div style="display:none;"><a id="GBS.PP2.w.0.0.0.2"></a></div><div style="display:none;"><a id="GBS.PR1"></a><a id="GBS.PR1.w.0.0.0"></a></div><div class="flow" style="">
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page" id="ORIG-GBS.PR1"></a>
<div class="gtxt_body" id="block.2.1.0.box.523.1154.471.38.q.70">
<a id="ORIG-GBS.PR1.w.1.0.0"></a><p class="gtxt_body" id="para.2.1.0.box.523.1154.471.38.q.70" style="font-size:104%;text-indent:1em;text-align:center;font-weight:bold;text-indent:0;"><a id="GBS.PR1.w.1.0.0"></a><a id="GBS.PR2"></a><a id="GBS.PR2.w.0.0.0"></a>OLD LOUISIANA</p><a id="GBS.PR3"></a><a id="GBS.PR3.w.0.0.0"></a><a id="GBS.PR3.w.1.0.0"></a>
</div><a id="GBS.PR3.w.2.0.0"></a><a id="GBS.PR3.w.3.0.0"></a>
</div><div style="display:none;"><a id="GBS.PR3.w.4.0.0"></a><a id="GBS.PR3.w.5.0.0"></a><a id="GBS.PR3.w.5.1.0"></a><a id="GBS.PR3.w.6.0.0"></a><a id="GBS.PR3.w.7.0.0"></a><a id="GBS.PR3.w.8.0.0"></a><a id="GBS.PR4"></a><a id="GBS.PR4.w.0.0.0"></a><a id="GBS.PR4.w.0.1.0"></a><a id="GBS.PR4.w.0.2.0"></a><a id="GBS.PR4.w.0.3.0"></a><a id="GBS.PR4.w.1.0.0"></a><a id="GBS.PR4.w.1.1.0"></a><a id="GBS.PR4.w.1.2.0"></a><a id="GBS.PR4.w.1.3.0"></a><a id="GBS.PR4.w.2.0.0"></a><a id="GBS.PR4.w.2.1.0"></a><a id="GBS.PR4.w.2.2.0"></a><a id="GBS.PR4.w.2.3.0"></a><a id="GBS.PR4.w.2.4.0"></a><a id="GBS.PR4.w.2.5.0"></a><a id="GBS.PR4.w.2.6.0"></a><a id="GBS.PR4.w.2.7.0"></a><a id="GBS.PR4.w.2.8.0"></a><a id="GBS.PR4.w.2.9.0"></a><a id="GBS.PR4.w.3.0.0"></a><a id="GBS.PR4.w.3.1.0"></a></div><div style="display:none;"><a id="GBS.PR5"></a><a id="GBS.PR5.w.0.0.0"></a></div>
<div style="display:none;"><a id="GBS.PR5.w.0.0.0.1"></a></div><div style="display:none;"><a id="GBS.PR5.w.0.1.0"></a></div><div class="flow" style="">
<a class="page full_page_skipped" id="ORIG-GBS.PR2"></a>
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PR3"></a>
<a id="GBS.PR6"></a><a id="GBS.PR6.w.0.0.0"></a><img alt="Image for page 4" src="data/content-0002.png" style="max-width:100%; max-height:100%"/><a id="GBS.PR6.w.0.0.0.1"></a></div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PR4"></a>
<a id="GBS.PR6.w.0.0.0.2"></a><img alt="Image for page 5" src="data/content-0003.png" style="max-width:100%; max-height:100%"/><a id="GBS.PR6.w.0.0.0.3"></a></div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page" id="ORIG-GBS.PR5"></a>
<div class="gtxt_body" id="block.6.0.0.box.506.1069.578.176.q.60">
<a id="ORIG-GBS.PR5.w.0.0.0"></a><p class="gtxt_body" id="para.6.0.0.box.765.1069.49.26.q.70" style="text-indent:1em;text-align:center;font-weight:bold;text-indent:0;">TO</p>
<a id="ORIG-GBS.PR5.w.0.1.0"></a><p class="gtxt_body" id="para.6.0.1.box.506.1144.578.101.q.60" style="text-align:center;font-weight:bold;font-variant:small-caps;text-indent:0;"><span style="font-variant:small-caps;">Mrs. </span>Cammie <span style="font-variant:small-caps;">Garrett </span><span style="font-variant:small-caps;">Henry </span><span style="font-variant:small-caps;">of </span><span style="font-variant:small-caps;">Melrose </span><span style="font-variant:small-caps;">Plantation </span></p>
</div>
</div><div style="display:none;"><a id="GBS.PR7"></a><a id="GBS.PR7.w.0.0.0"></a></div>
<div style="display:none;"><a id="GBS.PR7.w.0.0.0.1"></a></div><div style="display:none;"><a id="GBS.PR7.w.0.0.0.2"></a></div><div class="flow" style="">
</div>
<div style="display:none;"><a id="GBS.PR7.w.0.0.0.3"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content0004.vue?adbcd030